import axios from 'axios'

import HttpHelper from './HttpHelper'

const mergeAxiosConfig = (config, rest = {}) => {
    const hasRest = rest && Object.keys(rest).length > 0

    if (config && hasRest) {
        return { ...rest, ...config }
    }

    return config || (hasRest ? rest : undefined)
}

const proxiedRequest = (method, url, { data, params, config, ...rest } = {}) => {
    const finalUrl = HttpHelper.Proxy({ originalUrl: url, queryString: params })
    const finalConfig = mergeAxiosConfig(config, rest)

    switch (method) {
        case 'get':
        case 'delete':
            return axios[method](finalUrl, finalConfig)
        default:
            return axios[method](finalUrl, data, finalConfig)
    }
}

const directRequest = (method, url, { data, config, ...rest } = {}) => {
    const finalConfig = mergeAxiosConfig(config, rest)

    switch (method) {
        case 'get':
        case 'delete':
            return axios[method](url, finalConfig)
        default:
            return axios[method](url, data, finalConfig)
    }
}

export const proxiedGet = (url, options) => proxiedRequest('get', url, options)

export const proxiedPost = (url, data, options) =>
    proxiedRequest('post', url, { data, ...(options || {}) })

export const proxiedPut = (url, data, options) =>
    proxiedRequest('put', url, { data, ...(options || {}) })

export const proxiedDelete = (url, options) => proxiedRequest('delete', url, options)

export const proxiedPatch = (url, data, options) =>
    proxiedRequest('patch', url, { data, ...(options || {}) })

export const directGet = (url, options) => directRequest('get', url, options)

export const directPost = (url, data, options) => directRequest('post', url, { data, ...(options || {}) })

export const directPut = (url, data, options) => directRequest('put', url, { data, ...(options || {}) })

export const directDelete = (url, options) => directRequest('delete', url, options)

export const directPatch = (url, data, options) => directRequest('patch', url, { data, ...(options || {}) })

export const buildQueryObject = (...sources) =>
    sources.reduce((acc, source) => {
        if (!source || typeof source !== 'object') {
            return acc
        }
        Object.entries(source).forEach(([key, value]) => {
            if (value !== undefined && value !== null && value !== '') {
                acc[key] = value
            }
        })
        return acc
    }, {})

const apiClient = {
    proxiedGet,
    proxiedPost,
    proxiedPut,
    proxiedDelete,
    proxiedPatch,
    directGet,
    directPost,
    directPut,
    directDelete,
    directPatch,
    buildQueryObject
}

export default apiClient
